class PseudolinkRedirect extends HTMLElement {
  constructor (self) {
    self = super(self)
    const url = self.getAttribute('url')
    const method = self.getAttribute('method') || 'get'
    self.onclick = function () {
      fetch(url, { method: method })
        .then(function (response) {
          return response.text()
        })
        .then(function (link) {
          if (link && link.length > 0) {
            window.location.href = link.startsWith('http') ? link : `http://${link}`
          }
        })
    }
    return self
  }
}

export default PseudolinkRedirect
